import React, { useEffect, useState } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import * as Action from "../../../store/redux/client_reducer.js";
import * as Actionterminal from "../../../store/redux/terminal_reducer.js";
import { serverHost } from "../../../http_common.js";
import { userTypeOf } from "../../../authorization/companyUserAccess.js";
import { UserWorkspaceHeader } from "./UserWorkspace.jsx";
import "./UserWorkspace.css";

export default function UserProfile() {
  const { companiesDB } = useSelector(state => state.clientFunction);
  const company = companiesDB?.clientData || {};
  const [user, setUser] = useState(companiesDB?.staffData || {});
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    let current = true;
    axios.get(`${serverHost}/client/users/me`).then(({ data }) => {
      if (current && data?.status === 200) setUser(data.userData);
    }).catch(() => { if (current) setError("Unable to refresh profile details. Showing your signed-in account data."); });
    return () => { current = false; };
  }, []);
  const personal = user.personalInfo || {};
  const employment = user.employment || {};
  const rows = [
    ["Name", [personal.firstName, personal.otherName || personal.lastName].filter(Boolean).join(" ")],
    ["Username", user.userName], ["Staff ID", user.userId],
    ["Email", personal.email], ["Phone", personal.phone],
    ["Account type", userTypeOf(user) === "admin-user" ? "Administrative user" : userTypeOf(user) === "point-of-sale-user" ? "Point of Sale user" : "Not assigned"],
    ["Assigned role", user.role?.name], ["Job title", employment.jobTitle],
    ["Department", employment.department], ["Employment status", employment.status],
    ["Joined", employment.joinedAt], ["Branch", user.branchId || employment.branchId],
  ];
  const logout = () => { dispatch(Actionterminal.onlogOutTerminalAction()); dispatch(Action.logOut()); navigate("/access/client-portal/authentication/sign-in", {replace:true}); };
  return <div className="universe-user-page"><div className="universe-user-shell">
    <UserWorkspaceHeader company={company.businessProfile?.basicInfo?.businessName} onLogout={logout} />
    <div className="universe-user-hero"><div><Link to="/clients/users/workspace" className="universe-user-secondary"><ArrowBackOutlinedIcon fontSize="small" /> Back to workspace</Link><h1>My profile</h1><p>Your personal details and assigned company role.</p></div></div>
    {error && <p className="universe-user-message" role="status">{error}</p>}
    <section className="universe-user-card"><span className="universe-user-icon"><PersonOutlineIcon /></span><h2>Staff information</h2>
      <div className="universe-user-fields">{rows.map(([label, value]) => <div className="universe-user-field" key={label}><small>{label}</small><strong>{value || "Not provided"}</strong></div>)}</div>
      <p>Company information, billing and company-wide settings remain in the owner's Client Profile.</p>
    </section>
  </div></div>;
}
